import {inject} from '@angular/core';
import {CanDeactivateFn, Router} from '@angular/router';
import {ShadeToolsService} from '../services/shade-tools.service';
import {UnsavedChangesService} from '../services/unsaved-changes.service';

export const unsavedChangesGuard: CanDeactivateFn<unknown> = async () => {
  const unsavedChanges = inject(UnsavedChangesService);
  const shadeTools = inject(ShadeToolsService);
  const navigationId = inject(Router).currentNavigation()?.id;

  if (!unsavedChanges.hasUnsavedChanges()) {
    return true;
  }

  const previousDecision = navigationId === undefined ? null : unsavedChanges.getDecision(navigationId);
  if (previousDecision !== null) {
    return previousDecision;
  }

  const leave = await shadeTools.confirmDialog(
    'Unsaved Changes',
    'You have unsaved changes that will be lost if you leave. Do you want to leave without saving?',
    'Leave',
    'Stay',
  );

  if (navigationId !== undefined) {
    unsavedChanges.setDecision(navigationId, leave);
  }

  return leave;
};
